<template>
  <div class="selected-options">
    <div
      v-for="option in selected.slice(0, 3)"
      :key="`chip${option[idKey]}`"
      class="option-outline option"
    >
      <span class="chip-label">
        {{ typeof labelKey === 'function' ? labelKey(option) : option[labelKey] }}
      </span>
      <v-icon
        color="primary"
        class="ml-1 close-all-icon"
        icon="$close"
        :size="12"
        @click="emits('remove-option', option)"
      />
    </div>
    <span
      v-if="selected.length > 3"
      class="and-more"
    >+ {{ selected.length - 3 }} more</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  selected: {
    type: Array,
    default: () => ([]),
  },
  labelKey: {
    type: [String, Function],
    default: 'label',
  },
  idKey: {
    type: String,
    default: 'id',
  },
  optionTagMaxWidth: {
    type: Number,
    default: 300,
  },
});

const emits = defineEmits(['remove-option']);

const tagMaxWidth = computed(() => `${props.optionTagMaxWidth}px`);
</script>

<style lang="less" scoped>
.selected-options {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.option-outline {
  border-radius: 32px;
  height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  border: 1px solid @stroke-default;
}

.option {
  font-size: 12px;
  font-weight: 500;
  color: @text-brand;
  max-width: v-bind(tagMaxWidth);

  span {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .v-icon:hover {
    cursor: pointer;
  }
}

.delete-selection {
  &:hover {
    background-color: @bg-dark;
    cursor: pointer;
  }
}

.and-more {
  font-size: 12px;
  font-weight: 500;
  color: @text-brand;
  margin-left: 4px;
}
</style>
